<template>
  <div class="mobile mwr2025-dragon bg" :class="locale">
    <img src="~@/assets/imgs/act/mwr/dragon/dragon.gif" alt="dragon" class="dragon">
    <ActLang />
    <div class="content">
      <UserInfo class="user-info" />
      <TreasureBoxProgress class="treasure-box-progress" :currentProgress="state.currentProgress" @openRewardBoxDialog="openRewardBoxDialog" />
      <ServerProgress class="server-progress" :currentProgress="state.serverProgress" :total="state.serverTotal" />
      <GunSight class="gun-sight" @update:damage="addDamage" />
      <Mission class="mission" v-model:showMission="state.showMission" />
      <!-- mwr2025-dragon
      <button @click="goHome">go home</button>
      <button @click="goStats">go stats</button> -->
      <!-- <button class="btn" @click="addProgress">add progress</button>
      <button class="btn" @click="addServerProgress">add server progress</button> -->
      <div class="router-links">
        <div class="router-link home" @click="goHome"></div>
        <div class="router-link stats" @click="goStats"></div>
      </div>
      <div class="btns" :class="{ longScreen: state.scaleRate < 0.9 }">
        <div class="btn btn-rule" @click="state.ruleDialog.visible = true"></div>
        <div class="btn btn-mission" @click="state.showMission = true"></div>
        <div class="btn btn-record" @click="state.boxRecordDialog.visible = true"></div>
      </div>
    </div>
    <RuleDialog v-model="state.ruleDialog.visible" />
    <BoxRecordDialog v-model="state.boxRecordDialog.visible" />
    <RewardBoxDialog v-model="state.rewardBoxDialog.visible" :rewardData="state.rewardBoxDialog.rewardData" />
    <DragonDeadDialog v-model="state.DragonDeadDialog.visible" />
    <ActTimeDialog></ActTimeDialog>
  </div>
</template>

<script setup>
/* eslint-disable */
import { reactive, inject, watch, onMounted } from 'vue'
import { isMobile } from '@/utils'
import { useRouter } from 'vue-router'
import TreasureBoxProgress from './components/TreasureBoxProgress/index.vue'
import UserInfo from '../components/UserInfo/index.vue'
import ServerProgress from './components/ServerProgress/index.vue'
import GunSight from './components/GunSight/index.vue'
import Mission from './components/Mission/index.vue'
import MwrActApi from '@/config/mwrActApi'
import RuleDialog from '../components/Dialog/RuleDialog/index.vue'
import BoxRecordDialog from '../components/Dialog/BoxRecordDialog/index.vue'
import RewardBoxDialog from '../components/Dialog/RewardBoxDialog/index.vue'
import ActLang from '../components/ActLang/index.vue'
import RotatePhone from '@/components/RotatePhone/index.vue'
import DragonDeadDialog from '../components/Dialog/DragonDeadDialog/index.vue'
import { useI18n } from 'vue-i18n'
import ActTimeDialog from '../components/Dialog/ActTimeDialog/index.vue'
const { locale } = useI18n()

const mwrData = inject('mwrData')
const mwrFn = inject('mwrFn')
const state = reactive({
  currentProgress: 1000,
  serverProgress: 9000,
  serverTotal: 10000,
  showMission: false,
  ruleDialog: {
    visible: false
  },
  boxRecordDialog: {
    visible: false
  },
  rewardBoxDialog: {
    visible: false,
    rewardData: {}
  },
  DragonDeadDialog: {
    visible: false
  },
  scaleRate: 1,
})
// 按16:9的比例计算缩放比例
const calcScaleRate = () => {
  const screenWidth = window.innerWidth
  const screenHeight = window.innerHeight
  if (screenHeight > screenWidth) {
    return 1
  }
  const scaleRate = screenHeight / screenWidth * 16 / 9

  if (scaleRate > 1) {
    return 1
  }
  if (scaleRate < 0.6) {
    return 0.6
  }
  return scaleRate
}
onMounted(() => {
  state.scaleRate = calcScaleRate()
})
watch(() => mwrData.isDragonDead, (newVal) => {
  if (newVal && localStorage.getItem('mwr2025-dragon-dead') !== 'true') {
    state.DragonDeadDialog.visible = true
    localStorage.setItem('mwr2025-dragon-dead', 'true')
  }
}, { immediate: true })
const router = useRouter()
const cssType = isMobile ? 'mobile' : 'pc'
const goHome = () => {
  router.push({ name: 'MWR2025Home' })
}
const goStats = () => {
  router.push({ name: 'MWR2025Stats' })
}
const addProgress = () => {
  state.currentProgress += 2000
  if (state.currentProgress >= 20260) {
    state.currentProgress = 20260
  }
}
const addServerProgress = () => {
  state.serverProgress += 2000
  if (state.serverProgress >= state.serverTotal) {
    state.serverProgress = state.serverTotal
  }
}

const addDamage = async (damage) => {
  await MwrActApi.shootDragon({
    score: damage
  })
  mwrFn.updateTotalUserDpsScore(damage)
  mwrFn.updateUsedShotCount()
}
const openRewardBoxDialog = (rewardData) => {
  console.log('rewardData', rewardData)
  state.rewardBoxDialog.rewardData = rewardData
  state.rewardBoxDialog.visible = true
}
</script>

<style scoped lang="less" src="./mobile_style.less"></style>
